<template>
  <div>
    <div v-if="invoiceDetailsAvailable">
      <h1 class="header-style">
        Invoice
      </h1>
      <p class="subheading-style">
        {{ invoiceDetails.invoice_number }}
      </p>
      <v-card
        color="transparent"
        elevation="0"
      >
        <v-card-text>
          <v-form>
            <v-expansion-panels light>
              <v-expansion-panel>
                <v-row>
                  <v-col cols="10">
                    <v-text-field
                      v-model="from"
                      label="From"
                      light
                      disabled
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-expansion-panel-header />
                  </v-col>
                </v-row>

                <v-expansion-panel-content>
                  <v-text-field
                    v-model="fromAddressLine1"
                    label="Address"
                    dense
                    disabled
                    light
                  />
                  <v-text-field
                    v-model="fromAddressCity"
                    label="City"
                    dense
                    disabled
                    light
                  />
                  <v-text-field
                    v-model="fromAddressState"
                    label="State"
                    dense
                    disabled
                    light
                  />
                  <v-text-field
                    v-model="fromPin"
                    label="Postal Code"
                    dense
                    disabled
                    light
                  />
                  <v-text-field
                    v-model="fromAddressPhoneNumber"
                    label="Phone Number"
                    dense
                    disabled
                    light
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-expansion-panels light>
              <v-expansion-panel>
                <v-row>
                  <v-col cols="10">
                    <v-text-field
                      v-model="to"
                      label="To"
                      light
                      disabled
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-expansion-panel-header />
                  </v-col>
                </v-row>

                <v-expansion-panel-content>
                  <v-text-field
                    v-model="toAddressLine1"
                    label="Address"
                    dense
                    disabled
                    light
                  />
                  <v-text-field
                    v-model="toAddressCity"
                    label="City"
                    dense
                    disabled
                    light
                  />
                  <v-text-field
                    v-model="toAddressState"
                    label="State"
                    dense
                    disabled
                    light
                  />
                  <v-text-field
                    v-model="toPin"
                    label="Postal Code"
                    dense
                    disabled
                    light
                  />
                  <v-text-field
                    v-model="toAddressPhoneNumber"
                    label="Phone Number"
                    dense
                    disabled
                    light
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-text-field
              v-model="job"
              light
              color="#37474F"
              label="Job"
              background-color="transparent"
              class="small-select"
              disabled
            />
            <v-row>
              <v-col cols="6">
                <v-dialog
                  ref="fromDialog"
                  v-model="invoiceDateCalendar"
                  :return-value.sync="invoiceDate"
                  width="290px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="invoiceDate"
                      background-color="transparent"
                      label="Invoice Date"
                      light
                      v-bind="attrs"
                      disabled
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-if="invoiceDateCalendar"
                    v-model="invoiceDate"
                    full-width
                    color="#37474F"
                    light
                    @input="$refs.fromDialog.save(invoiceDate)"
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="#37474F"
                      @click="invoiceDateCalendar = false"
                    >
                      Cancel
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="6">
                <v-dialog
                  ref="toDialog"
                  v-model="dueDateCalendar"
                  :return-value.sync="dueDate"
                  width="290px"
                >
                  <template #activator="{ on, attrs }">
                    <v-text-field
                      v-model="dueDate"
                      background-color="transparent"
                      label="Due date"
                      light
                      v-bind="attrs"
                      disabled
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-if="dueDateCalendar"
                    v-model="dueDate"
                    full-width
                    color="#37474F"
                    light
                    @input="$refs.toDialog.save(dueDate)"
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="#37474F"
                      @click="dueDateCalendar = false"
                    >
                      Cancel
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>
            <br>
            <v-simple-table light>
              <template #default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Item
                    </th>
                    <th class="text-left">
                      Unit Price
                    </th>
                    <th class="text-left">
                      Qty.
                    </th>
                    <th class="text-left">
                      Amt.
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in itemsList"
                    :key="index"
                  >
                    <td>{{ item.itemName }}</td>
                    <td>{{ item.unitPrice }}</td>
                    <td>{{ item.quantity }}</td>
                    <td>{{ item.amount }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-form>
          <hr>
          <br>
          <div>
            <div class="total-amt">
              <h4>Total</h4>
              <h4>$ {{ totalAmount }}</h4>
            </div>
            <div class="total-amt pt-2">
              <h4>GST (10%)</h4>
              <span>
                <h4>$ {{ taxAmount }}</h4>
                <hr class="mt-1">
              </span>
            </div>
            <div class="total-amt">
              <h3>Grand Total</h3>
              <h3>$ {{ grandTotal }}</h3>
            </div>
            <br>
          </div>
          <hr>
          <br>
          <div class="addBtn-container">
            <v-btn
              v-if="invoiceDetails.document_file !== null"
              class="btn-style"
              color="#64CA7F"
              elevation="0"
              @click="downloadInvoice(invoiceDetails.document_file)"
            >
              Download
              <v-icon>mdi-download</v-icon>
            </v-btn>
            <v-btn
              v-else
              class="btn-style"
              color="#64CA7F"
              elevation="0"
              @click="createInvoice()"
            >
              Create Invoice
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
      <br>
      <br>
    </div>
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import moment from 'moment';
export default {
  name: 'InvoiceDetailsPage',
  components: {
    'centre-spinner': spinner,
  },
  data: () => ({
    loading: false,
    from: null,
    job: null,
    to: null,
    abnNumber: null,
    invoiceDate: moment().format('YYYY-MM-DD'),
    invoiceDateCalendar: false,
    dueDate: null,
    dueDateCalendar: false,
    toAddressPhoneNumber: null,
    toAddressState: null,
    toAddressCity: null,
    toAddressLine1: null,
    fromAddressPhoneNumber: null,
    fromAddressState: null,
    fromAddressCity: null,
    fromAddressLine1: null,
    fromPin: null,
    toPin: null,
    showAddForm: false,
    itemsList: [],
  }),
  computed: {
    invoiceDetails () {
      return this.$store.getters['invoice/getInvoiceDetails'];
    },
    totalAmount () {
      let totalAmount = 0;
      this.itemsList.filter(item => {
        totalAmount = totalAmount + item.amount;
      });
      return totalAmount;
    },
    taxAmount () {
      return (this.totalAmount * 10) / 100;
    },
    grandTotal () {
      return this.totalAmount + this.taxAmount;
    },
    invoiceDetailsAvailable () {
      if (Object.keys(this.invoiceDetails).length !== 0) {
        return true;
      }
      return false;
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
  },
  async mounted () {
    this.loading = true;
    await this.getInvoiceDetails();
    await this.loadOnMount();
    this.loading = false;
  },
  methods: {
    async getInvoiceDetails () {
      const invoiceId = this.$route.params.id;
      await this.$store.dispatch('invoice/fetchInvoiceDetails', {
        invoiceId: invoiceId,
      });
    },
    loadOnMount () {
      this.from = this.invoiceDetails.from.company.name;
      this.to = this.invoiceDetails.to.name;
      this.fromAddressLine1 = this.invoiceDetails.from.company.address.line1;
      this.fromAddressCity = this.invoiceDetails.from.company.address.city;
      this.fromAddressState = this.invoiceDetails.from.company.address.state;
      this.fromAddressPhoneNumber = this.invoiceDetails.from.company.phone_number;
      this.abnNumber = this.invoiceDetails.from.company.abn_number;
      this.fromPin = this.invoiceDetails.from.company.address.postal_code;
      this.toPin = this.invoiceDetails.to.address.postal_code;
      this.toAddressLine1 = this.invoiceDetails.to.address.line1;
      this.toAddressCity = this.invoiceDetails.to.address.city;
      this.toAddressState = this.invoiceDetails.to.address.state;
      this.toAddressPhoneNumber = this.invoiceDetails.to.phone_number;
      this.dueDate = this.invoiceDetails.due_date;
      this.itemsList = this.invoiceDetails.line_items;
      this.job = this.invoiceDetails.job.name;
    },
    async downloadInvoice (file) {
        this.loading = true;
        await this.$store.dispatch('invoice/downloadInvoice', {
            externalId: this.selectedOrganization.organization.external_id,
            invoiceId: file.id,
            fileName: file.unique_file_name,
        });
        this.loading = false;
    },
    createInvoice () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'Generate Draft Invoices' });
      }, 1000);
    },
  },
};
</script>

<style scoped>
.close-btn-container {
  width: 100%;
  text-align: right;
}

.close-button {
  position: absolute;
  top: 0;
}

.header-style {
  margin-top: 0px;
}

.subheading-style {
  color: #CCC;
}

.theme--dark.v-list {
  background-color: white !important;
}

.theme--dark >>> .v-list-item {
  color: #37474f !important;
}

.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: transparent !important;
}

.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  /* padding: 0 !important; */
  box-shadow: none !important;
}

.v-expansion-panel >>> .v-expansion-panel-header {
  padding: 0 !important;
  display: flex !important;
  align-items: start !important;
}

.v-expansion-panel-header >>> .v-expansion-panel-header__icon {
  margin-top: 12px !important;
  display: flex !important;
}

.v-item-group {
  position: unset !important;
}

.addBtn-container .v-btn {
  width: 100% !important;
}

.v-card__text {
  padding: 16px 0px 16px 0px !important;
}

.total-amt {
  display: flex;
  justify-content: space-between;
}
</style>
